import React, { Component } from "react";
import { CRUDFunction } from "../../../reduxCURD/container";
import { curdActions } from "../../../reduxCURD/actions";
import SpinnerLoader from "../../Common/SpinnerLoader";
import { themeService } from "../../../theme/service/activeTheme.service";
import ConfirmationDialog from "../../Common/ConfirmationDialog";
import { MyButton } from "../../Common/Forms/formsMiscItems";
import { ButtonStyle } from "../../../style/basic/commonControls";
import { languageService } from "../../../Language/language.service";
import { ToastService } from "../../../utils/toastify";
import TooltipContainer from "../../../libraries/TooltipContainer";
import { getInProgressMaintenance } from "../../../reduxRelated/actions/journeyPlanHelperActions";
import "./fieldConfiguration.css";
import ConfiguredFieldsTable from "./ConfiguredFieldsTable";

class FieldsConfiguration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assetTests: [],
      loading: true,
      selectedTestCode: null,
      formData: [],
      configured: {},
      showSaveConfirm: false,
    };
  }

  fetchInProgressInspection = () => {
    const { selectedAsset, getInProgressMaintenance } = this.props;

    if (!selectedAsset || !selectedAsset._id || !getInProgressMaintenance) return;

    const criteria = JSON.stringify({
      assetIds: [selectedAsset._id],
    });

    getInProgressMaintenance(criteria);
  };

  fetchnonRemovedEnabledTests = () => {
    const { selectedAsset } = this.props;
    if (selectedAsset && selectedAsset._id) {
      const query = `?assetId=${selectedAsset._id}`;
      this.props.getAssetTests("/nonRemovedEnabledTests" + query);
    }
  };

  componentDidMount() {
    this.props.asset && this.props.asset.updatedTestCode && this.handleTestClick(this.props.asset.updatedTestCode); //simulate click if already updated to retain state
    this.fetchnonRemovedEnabledTests();
    this.fetchInProgressInspection();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.assetTestActionType === "ASSETTESTS_READ_SUCCESS" && prevProps.assetTestActionType !== this.props.assetTestActionType) {
      this.setState({
        assetTests: this.props.assetTests || [],
        loading: false,
      });
    }

    if (this.props.assetTestActionType === "ASSETTESTS_READ_REQUEST" && prevProps.assetTestActionType !== this.props.assetTestActionType) {
      this.setState({ loading: true });
    }

    if (this.props.assetTestActionType === "ASSETTESTS_READ_FAILURE" && prevProps.assetTestActionType !== this.props.assetTestActionType) {
      this.setState({ loading: false });
    }

    if (
      this.props.applicationlookupsActionType === "APPLICATIONLOOKUPSS_READ_SUCCESS" &&
      prevProps.applicationlookupsActionType !== this.props.applicationlookupsActionType
    ) {
      this.setState({
        formData: this.props.applicationlookupss || [],
      });
    }

    if (this.props.assetActionType === "ASSET_UPDATE_SUCCESS" && prevProps.assetActionType !== this.props.assetActionType) {
      const selectedTest = this.getSelectedTest();
      if (selectedTest) {
        const updatedHardControlArray = this.getUpdatedHardControlArray(this.state.configured, selectedTest, this.props.selectedAsset);
        this.setState((prevState) => ({
          assetTests: prevState.assetTests.map((test) => {
            if (test.testCode === selectedTest.testCode) {
              const formFieldsCompletion = test.formFieldsCompletion || {};
              const controlOverrides = formFieldsCompletion.controlOverrides || {};
              const onStart = controlOverrides.onStart || {};
              return {
                ...test,
                formFieldsCompletion: {
                  ...formFieldsCompletion,
                  controlOverrides: {
                    ...controlOverrides,
                    onStart: {
                      ...onStart,
                      hardControlArray: updatedHardControlArray,
                    },
                  },
                },
              };
            }
            return test;
          }),
          configured: {},
          showSaveConfirm: false,
        }));

        ToastService.Success(languageService("Configured successfully"));
        this.fetchnonRemovedEnabledTests();
        this.props.reFetchAsset();
      }
    }

    if (this.props.assetActionType === "ASSET_UPDATE_FAILURE" && prevProps.assetActionType !== this.props.assetActionType) {
      const err = this.props.assetErrorMessage || "";
      ToastService.Error(languageService("Configure failed"), err.toString ? err.toString() : err);
      this.setState({ showSaveConfirm: false });
      this.fetchnonRemovedEnabledTests();
    }
  }

  handleTestClick = (testCode) => {
    this.setState({ selectedTestCode: testCode, formData: [], configured: {} });
    const listName = "appForms";
    const codes = testCode;
    this.props.getApplicationlookupss(`/${listName}/${codes}`);
  };

  getSelectedTest = () => {
    const { assetTests, selectedTestCode } = this.state;
    return assetTests.find((t) => t.testCode === selectedTestCode);
  };

  inProgressInspection = () => {
    const { inProgressMaintenances } = this.props;
    return Array.isArray(inProgressMaintenances) && inProgressMaintenances.length > 0;
  };

  isTestCompleted = (test) => {
    const targetTest = test || this.getSelectedTest();
    const completedFields =
      targetTest && targetTest.formFieldsCompletion && Array.isArray(targetTest.formFieldsCompletion.completedFields)
        ? targetTest.formFieldsCompletion.completedFields
        : [];
    return completedFields.length > 0;
  };

  getHardControlArray = (selectedTest, asset) => {
    let arrToReturn = [];
    if (!selectedTest) return arrToReturn;
    if (!asset) return arrToReturn;
    if (!asset.controlOverrides) return arrToReturn;
    let formId = selectedTest.testCode;
    let objFound = asset.controlOverrides.onStart.find((onStartObj) => onStartObj.form === formId);
    if (!objFound) return arrToReturn;
    arrToReturn = objFound.hardControlArray;
    return arrToReturn;
  };

  getUpdatedHardControlArray = (configuredOverrides, selectedTest, asset) => {
    const baseArray = this.getHardControlArray(selectedTest, asset);
    const set = new Set(baseArray);
    if (configuredOverrides) {
      Object.keys(configuredOverrides).forEach((fid) => {
        const val = configuredOverrides[fid];
        if (val) {
          set.add(fid);
        } else {
          set.delete(fid);
        }
      });
    }
    return Array.from(set).filter((fid) => fid !== "assetId");
  };

  toggleConfigured = (fieldId, defaultChecked) => {
    if (this.isTestCompleted() || this.inProgressInspection()) {
      return;
    }
    const selectedTest = this.getSelectedTest();
    this.setState((prev) => {
      const currentVal = prev.configured.hasOwnProperty(fieldId) ? prev.configured[fieldId] : defaultChecked;
      const nextVal = !currentVal;
      const nextConfigured = { ...prev.configured, [fieldId]: nextVal };
      return { configured: nextConfigured };
    });
  };

  openSaveConfirm = () => {
    this.setState({ showSaveConfirm: true });
  };

  closeSaveConfirm = () => {
    this.setState({ showSaveConfirm: false });
  };

  handleConfirmSave = () => {
    const selectedTest = this.getSelectedTest();
    if (!selectedTest) return;

    const updatedHardControlArray = this.getUpdatedHardControlArray(this.state.configured, selectedTest, this.props.selectedAsset);
    const assetId = selectedTest.assetId || selectedTest._id;

    const payload = {
      testCode: selectedTest.testCode,
      hardControlArray: updatedHardControlArray,
    };
    this.props.updateAsset(payload, `updateHardControlArray/${assetId}`);
  };

  render() {
    const { assetTests, loading, selectedTestCode, formData, configured, showSaveConfirm } = this.state;
    const record = formData && formData.length > 0 ? formData[0] : null;
    const fields = record && Array.isArray(record.opt1) ? record.opt1 : [];
    const selectedTest = this.getSelectedTest();
    const selectedTestCompleted = this.isTestCompleted(selectedTest);
    const hardControlArray = this.getHardControlArray(selectedTest, this.props.selectedAsset);
    const inProgressInspection = this.inProgressInspection();
    const lockTooltipText = languageService("Inspection is in progress");
    const { selectedAsset } = this.props;
    if (loading) return <SpinnerLoader loading={loading} />;

    return (
      <div className="VOU_Container">
        <h3 className="VOU_Header">
          FIELDS CONFIGURATION
          {inProgressInspection && (
            <TooltipContainer tooltipText={lockTooltipText}>
              <span className="warning-text">Inspection in Progress ⚠️</span>
            </TooltipContainer>
          )}
        </h3>

        <div className="fields-config-layout">
          {/* Left Side - Asset Tests */}
          <div className={`asset-tests-panel ${inProgressInspection ? "disabled-panel" : ""}`}>
            <div className="asset-tests-header">Asset Tests</div>

            {assetTests && assetTests.length > 0 ? (
              assetTests.map((test) => {
                const isCompleted = this.isTestCompleted(test);
                const isLockedByJourneyPlan = inProgressInspection;
                const isDisabled = isCompleted || isLockedByJourneyPlan;

                const tooltipText = isCompleted
                  ? languageService("Test in progress")
                  : isLockedByJourneyPlan
                  ? languageService("Inspection is in progress")
                  : "";

                const showCompletedWarning = isCompleted && !inProgressInspection;

                return (
                  <div
                    className={`asset-test-row ${selectedTestCode === test.testCode ? "selected" : ""} ${isDisabled ? "disabled" : ""}`}
                    onClick={isDisabled ? undefined : () => this.handleTestClick(test.testCode)}
                  >
                    <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
                      <span>{test.title}</span>
                      {showCompletedWarning && (
                        <TooltipContainer tooltipText={tooltipText}>
                          <span className="warning-icon">⚠️</span>
                        </TooltipContainer>
                      )}
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="config-info">No tests found</div>
            )}
          </div>

          {/* Right Side - Configured Fields */}
          <ConfiguredFieldsTable
            selectedTest={selectedTest}
            selectedTestCode={selectedTestCode}
            fields={fields}
            configured={configured}
            hardControlArray={hardControlArray}
            toggleConfigured={this.toggleConfigured}
            inProgressInspection={inProgressInspection}
            assetName={selectedAsset ? selectedAsset.unitId : ""}
            selectedTestCompleted={selectedTestCompleted}
            openSaveConfirm={this.openSaveConfirm}
          />

          {showSaveConfirm && (
            <ConfirmationDialog
              modal={showSaveConfirm}
              toggle={this.closeSaveConfirm}
              headerText="Confirm Save"
              confirmationMessage="Are you sure you want to save these configurations?"
              handleResponse={(ok) => (ok ? this.handleConfirmSave() : this.closeSaveConfirm())}
            />
          )}
        </div>
      </div>
    );
  }
}

const getAssetTests = curdActions.getAssetTests;
const getApplicationlookupss = curdActions.getApplicationlookupss;
const updateAsset = curdActions.updateAsset;

const actionOptions = {
  create: false,
  update: true,
  read: true,
  delete: false,
  others: { getAssetTests, getApplicationlookupss, updateAsset, getInProgressMaintenance },
};

const variables = {
  assetReducer: { asset: {}, assets: [] },
  assetTestReducer: { assetTests: [] },
  applicationlookupsReducer: { applicationlookupss: [] },
  journeyPlanHelperReducer: { inProgressMaintenances: [] },
};
let fieldConfigReducers = ["assetReducer", "assetTestReducer", "applicationlookupsReducer", "journeyPlanHelperReducer"];
export default CRUDFunction(FieldsConfiguration, "FieldsConfigurationData", actionOptions, variables, fieldConfigReducers, "asset");



// WEBPACK FOOTER //
// ./src/components/AssetView/FieldsConfiguration/index.jsx